import Button from '@betterfunnel/ui-core/Button';
import { Lead } from '@betterfunnel/types';
import { collection } from 'firebase/firestore';
import { useContext, useMemo } from 'react';
import { LeadsTable } from '../components/LeadsTable';
import { UserContext } from '../contexts/UserContext';
import { emptyConverter } from '../utils';

export default function Leads() {
  const { selectedAccount } = useContext(UserContext);
  const query = useMemo(() => {
    if (!selectedAccount) return;
    return collection(selectedAccount.ref, 'leads').withConverter(
      emptyConverter<Lead>(),
    );
  }, [selectedAccount]);

  return (
    <div className="flex h-full flex-col gap-8">
      <div className="flex h-12 items-center border-b border-gray-300 pb-3">
        <div className="sm:flex-auto">
          <h1 className="text-2xl font-semibold leading-6 text-gray-900">
            Leads
          </h1>
          {/* <p className="mt-2 text-sm text-gray-700">
            All your leads in one place.
          </p> */}
        </div>

        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <Button>Export as CSV (coming soon)</Button>
        </div>
      </div>
      <div className="relative flex-1">
        {query && <LeadsTable query={query} />}
      </div>
    </div>
  );
}
